import { defineStore } from 'pinia';

export const useGoogleSecretsStore = defineStore('googleSecrets', {
  state: () => ({
    hmacKey: null,
    xMacysApiKey: null,
  }),
});
